module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgement"
    }
  }, [_c('h1', [_vm._v("Acknowledgement")]), _vm._v(" "), _c('p', [_vm._v("I wish to express my gratitude for the excellent services rendered to Tommy, Bobby, and Daisy, by Mary Lynn Lackie, DVM, and Elizabeth Motluk, DVM, (Village Veterinary Clinic); Nicole Lalande (Eastway Pet Resort); Lynn Menard (Everything Raw Doggie Café); Chloé Bissonnette (Aux Pitous Adorables); Madison Peterman (Groomer Madison); and John Philip Stratton (John Philip Photography).")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("I also wish to express my gratitude the editing services rendered by Adam Paul (Fiverr), and Julie Wehbe (Julie Wehbe Online Services LTD).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be8e4d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0